<template>
<div id="bookingApp">
  <booking-navi v-if="isIE"></booking-navi>
  <booking-navi v-else
    v-sticky="{ zIndex: 1000, stickyTop: appControl.stickyTop }">
  </booking-navi>
  <div v-if="!initDataLoaded"
    class="data-loading"
    v-loading="!initDataLoaded"
    :element-loading-text="$t('ibe.text_loader_init')">
  </div>
  <template v-else>
    <el-row v-if="!dialogIbeFatalVisible"
      :gutter="10">
      <el-col
        v-loading="fetchingData"
        :element-loading-text="$t('ibe.text_loader_step')"
        :xs="24" :sm="24" :md="24" :lg="16" :xl="16"
        style="min-height: 100px;">
        <transition
          name="el-fade-in-linear"
          mode="out-in"
          appear>
          <router-view
            ref="bookingStep">
            <template v-if="mediaquery > 1"
              slot="bookingButtons">
              <el-row
                type="flex"
                :justify="!appControl.ibeNewWindow || $route.name != 1 ? 'space-between' : 'end'">
                <el-button v-if="!appControl.ibeNewWindow || $route.name != 1"
                  type="text"
                  icon="el-icon-arrow-left"
                  size="large"
                  @click="back">
                  {{ $t('ibe.step' + $route.name + '_back') }}
                </el-button>
                <el-button v-if="showBookActionLoader"
                  type="primary"
                  class="cta-button"
                  :loading="showBookActionLoader"
                  size="large">
                  {{ $t('ibe.text_loader_price') }}
                </el-button>
                <el-button v-else-if="ibeResponse.responseType === 'WARNING'"
                  type="primary"
                  size="large"
                  class="cta-button"
                  @click="$router.push('/formular')">
                  {{ $t('ibe.step_formular_forward') }}
                  <i class="el-icon-arrow-right el-icon-right"></i>
                </el-button>
                <el-button v-else
                  type="primary"
                  size="large"
                  class="cta-button"
                  @click="submitStep">
                  {{ $t('ibe.step' + $route.name + '_forward') }}
                  <i class="el-icon-arrow-right el-icon-right"></i>
                </el-button>
              </el-row>
            </template>
            <template v-else
              slot="bookingButtons">
              <el-row
                type="flex"
                justify="center">
                <el-button v-if="showBookActionLoader"
                  type="primary"
                  :loading="showBookActionLoader"
                  size="large"
                  style="width: 100%; margin-bottom: 10px;">
                  {{ $t('ibe.text_price_loader') }}
                </el-button>
                <el-button v-else-if="ibeResponse.responseType === 'WARNING'"
                  type="primary"
                  size="large"
                  @click="$router.push('/formular')"
                   style="width: 100%; margin-bottom: 10px;">
                  {{ $t('ibe.step_formular_forward') }}
                  <i class="el-icon-arrow-right el-icon-right"></i>
                </el-button>
                <el-button v-else
                  type="primary"
                  size="large"
                  style="width: 100%; margin-bottom: 10px;"
                  @click="submitStep">
                  {{ $t('ibe.step' + $route.name + '_forward') }}
                  <i class="el-icon-arrow-right el-icon-right"></i>
                </el-button>
              </el-row>
              <el-row v-if="!appControl.ibeNewWindow"
                type="flex"
                justify="start">
                <el-button
                  type="text"
                  icon="el-icon-arrow-left"
                  size="large"
                  @click="back">
                  {{ $t('ibe.step' + $route.name + '_back') }}
                </el-button>
              </el-row>
            </template>
            <div
              style="font-size: 12px;"
              slot="bookingNotes">
              <el-row v-if="appControl.showDataSecurityNote"
                style="margin-top: 5px;">
                <el-col
                  :span="mediaquery === 1 ? 24 : 18"
                  :offset="mediaquery === 1 ? 0 : 3">
                  <span
                    style="display: table-cell; width: 22px">
                    <i class="material-icons el-button--text">
                      security
                    </i>
                  </span>
                  <span
                    style="display: table-cell; vertical-align:middle;">
                    {{ $t('ibe.text_data_security_note') }}
                  </span>
                </el-col>
              </el-row>
              <el-row v-if="appControl.showSSLNote"
                style="margin-top: 5px;">
                <el-col
                  :span="mediaquery === 1 ? 24 : 18"
                  :offset="mediaquery === 1 ? 0 : 3">
                  <span
                    style="display: table-cell; width: 22px">
                    <i class="material-icons el-button--text">
                      lock_outline
                    </i>
                  </span>
                  <span
                    style="display: table-cell; vertical-align:middle;">
                     {{ $t('ibe.text_ssl_note') }}
                  </span>
                </el-col>
              </el-row>
              <el-row v-if="appControl.showRequiredFieldNote"
                style="margin-top: 5px;">
                <el-col
                  :span="mediaquery === 1 ? 24 : 18"
                  :offset="mediaquery === 1 ? 0 : 3">
                  <span>
                     {{ $t('ibe.text_required_field_note') }}
                  </span>
                </el-col>
              </el-row>
            </div>
          </router-view>
        </transition>
      </el-col>
      <el-col v-if="mediaquery >= 4 && isIE"
        :span="8">
        <div>
          <booking-sidebar></booking-sidebar>
          <consultant-box v-if="appControl.show.consultantBox && consultant.name !== ''"></consultant-box>
        </div>
      </el-col>
      <el-col v-else-if="mediaquery >= 4"
        :span="8"
        v-sticky="{ zIndex: 999, stickyTop: appControl.stickyTop + 46 }">
        <div>
          <booking-sidebar></booking-sidebar>
          <consultant-box v-if="appControl.show.consultantBox && consultant.name !== ''"></consultant-box>
        </div>
      </el-col>
      <el-col v-else
        :span="24">
        <div v-if="appControl.show.consultantBox && consultant.name !== ''"
          class="bottom-fix bottom-right-icon"
          @click="dialogSupportVisible = true">
          <i class="material-icons el-button--text">contact_phone</i>
        </div>
        <div
          class="bottom-fix bottom-right-info-icon"
          @click="dialogOperatorInfoVisible = true">
          <i class="el-icon-info el-button--text"></i>
        </div>
        <booking-summary></booking-summary>
      </el-col>
    </el-row>
    <el-dialog
      :visible.sync="dialogSupportVisible"
      :width="mediaquery == 1 ? '90%' : '60%'">
      <consultant-box v-if="consultant.name !== ''"></consultant-box>
      <div style="height: 20px"> </div>
    </el-dialog>
    <el-dialog
      :visible.sync="dialogOperatorInfoVisible"
      :width="mediaquery == 1 ? '90%' : '60%'"
      :title="$t('ibe.headline_operator_info')">
      <div v-for="(info, index) in operatorInfo"
        :key="'operatorInfo_' + index">
        <h4>{{ info.headline }}</h4>
        <ul><span v-html="info.list"></span></ul>
      </div>
    </el-dialog>
    <el-dialog
      :title="$t('ibe.headline_ibeFatal')"
      :visible.sync="dialogIbeFatalVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      :width="mediaquery <= 3 ? '90%' : '60%'"
      class="modal">
      {{ $t('ibe.text_ibeFatal') }}
      <span
        slot="footer"
        class="dialog-footer">
        <el-row v-if="mediaquery > 1"
          type="flex"
          justify="space-between"
          style="margin-top: 20px">
          <el-button
            type="primary"
            @click="start"
            class="button">
            {{ $t('ibe.button_start') }}
          </el-button>
          <el-button
            type="primary"
            @click="offer"
            class="button">
            {{ $t('ibe.button_offer') }}
          </el-button>
        </el-row>
        <template v-else>
          <el-row
            type="flex"
            justify="center">
            <el-button
              @click="offer"
              class="button"
              style="width: 100%">
              {{ $t('ibe.button_offer') }}
            </el-button>
          </el-row>
          <el-row
            type="flex"
            justify="center">
            <el-button
              @click="start"
              class="button"
              style="width: 100%">
              {{ $t('ibe.button_start') }}
            </el-button>
          </el-row>
        </template>
      </span>
    </el-dialog>
  </template>
  <div v-if="showTrace"
    v-html="ibeResponse.traceData">
  </div>
</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import BookingNavi from './components/BookingNavi'
import BookingSidebar from './components/BookingSidebar'
import BookingSummary from './components/BookingSummary'
import ConsultantBox from './components/modules/ConsultantBox'
import VueSticky from 'vue-sticky'
import { config } from "@/config/config";

export default {
  name: 'BookingApp',
  data () {
    return {
      dialogSupportVisible: false,
      dialogOperatorInfoVisible: false,
      dialogIbeFatalVisible: false,
      idScrollToElement: 0,
      showTrace: !!(window.initData.debugMode & (1 << 0)),
      enableAllTabs: !!(window.initData.debugMode & (1 << 1))
    }
  },
  created () {
    this.setAppControl(window.appControl).then(() => {
      this.getBookingData()
    })
    window.addEventListener('orientationchange', this.handleOrientationChange)
    window.addEventListener('resize', this.handleResize)
    this.$router.beforeEach((to, from, next) => {
      this.$message.closeAll()
      // pageview tracking
      if (window.google_tag_manager && window.dataLayer && this.appControl.useGoogleTagManager) {
        window.dataLayer.push({
          'vPageURL': 'bookingstep' + to.name,
          'vPageTitle': 'Buchen - ' + this.$t('ibe.tab' + to.name),
          'event': 'updVirtualPageview'
        })
      }
      if (window.ga && typeof window.ga === 'function' && this.appControl.useGoogleAnalytics) {
        window.ga('send', 'pageview', 'bookingstep' + to.name)
      }
      if ((to.name <= this.nextStep && !this.bookFinished) || this.enableAllTabs) {
        this.setNextStep(to.name)
        next()
      } else if (isNaN(to.name)) {
        next()
      }
    })
  },
  mounted () {
    this.setAvailableWidth(document.getElementById('bookingApp').offsetWidth)
    this.setMediaquery(this.getMediaquery())
    this.setInnerHeight(window.innerHeight)
  },
  destroyed () {
    window.removeEventListener('orientationchange', this.handleOrientationChange)
    window.removeEventListener('resize', this.handleResize)
  },
  computed: {
    ...mapGetters('booking', [
      'appControl',
      'initDataLoaded',
      'mediaquery',
      'nextStep',
      'bookFinished',
      'ibeResponse',
      'object',
      'consultant',
      'dropdownAppeared',
      'showBookActionLoader',
      'fetchingData',
      'operatorInfo',
      'availableUnits'
    ]),
    isIE () {
      let ua = window.navigator.userAgent
      if (ua.indexOf('MSIE') > 0) {
        return true
      }
      if (ua.indexOf('Edge/') > 0) {
        return true
      }
      if (ua.indexOf('Trident/') > 0) {
        return true
      }
      return false
    }
  },
  methods: {
    ...mapActions('booking', [
      'getBookingData',
      'setAvailableWidth',
      'setInnerHeight',
      'setMediaquery',
      'setAppControl',
      'setNextStep',
      'changeCountTravelers'
    ]),
    handleResize () {
      this.setAvailableWidth(document.getElementById('bookingApp').offsetWidth)
      this.setInnerHeight(window.innerHeight)
      this.setMediaquery(this.getMediaquery())
    },
    handleOrientationChange () {
      this.setAvailableWidth(document.getElementById('bookingApp').offsetWidth)
      this.setInnerHeight(window.innerHeight)
    },
    start () {
      window.location.href = config.webRoot
    },
    offer () {
      const path = window.initData.language.toLowerCase() === 'en' ? 'en/cruise/' : 'reise/'
      window.location.href = `${path}${this.object.urls.mediaObject}?tab=TerminePreise`
    },
    back () {
      this.$refs['bookingStep'].back()
    },
    showRequiredMessage () {
      this.$message({
        message: this.$t('ibe.text_required'),
        type: 'error',
        duration: this.appControl.timeouts.ruleMessage
      })
    },
    checkRefs (refs, forms) {
      this._each(refs, obj => {
        if (this._isArray(obj)) {
          this.checkRefs(obj, forms)
        } else {
          if (obj.$el && obj.$el.localName === 'form') {
            forms.push(this.$isValidForm(obj))
            if (!forms[forms.length - 1] && this.idScrollToElement === 0) {
              let elem = this._find(obj.fields, {'validateState': 'error'})
              this.idScrollToElement = elem.$el.id
            }
          } else {
            this.checkRefs(obj.$refs, forms)
          }
        }
      })
    },
    submitStep () {
      let forms = []
      let ref = this.$refs['bookingStep']
      this.idScrollToElement = 0

      if (this.$route.name === 5) {
        ref.print()
      } else {
        this.checkRefs(ref.$refs, forms)
        if (forms.every(Boolean)) {
          this.setNextStep(this.$route.name + 1)
          this.$router.push({ name: this.$route.name + 1 })
        } else {
          this.$scrollTo('#' + this.idScrollToElement, this.appControl.scrollDuration)
          this.showRequiredMessage()
        }
      }
    },
    getMediaquery () {
      let mediaKey = 4
      this._each(this.appControl.media, (val, key) => {
        if (window.matchMedia(val).matches) {
          mediaKey = parseInt(key)
        }
      })
      return mediaKey
    }
  },
  directives: {
    'sticky': VueSticky
  },
  components: {
    bookingNavi: BookingNavi,
    bookingSidebar: BookingSidebar,
    bookingSummary: BookingSummary,
    consultantBox: ConsultantBox
  },
  watch: {
    initDataLoaded () {
      this.$scrollTo(0, this.appControl.scrollDuration)
      this.changeCountTravelers({
        index: 0,
        value: this.availableUnits[0].ibeData.maxErw === 1 ? 1 : 2,
        type: 'adults'
      })
      if (this.object.ibeData.waitList) {
        this.$router.replace('/waitlist')
      } else {
        this.$router.replace('/step1')
      }
    },
    ibeResponse () {
      if (this.ibeResponse.responseType === 'WARNING') {
        this.$notify.warning({
          title: this.$t('ibe.headline_info_ibeWarning'),
          message: this.ibeResponse.messageText,
          duration: this.appControl.timeouts.ibeWarning
        })
      }
      if (this.ibeResponse.responseType === 'ERROR') {
        this.$notify.error({
          title: this.$t('ibe.headline_info_ibeError'),
          message: this.ibeResponse.messageText,
          duration: this.appControl.timeouts.ibeError
        })
        this.$router.push('/formular')
      }
      if (this.ibeResponse.responseType === 'FATAL') {
        this.dialogIbeFatalVisible = true
      }
    }
  }
}
</script>
